<template>
  <b-container class="text-center register-page">
    <a @click="goBack()">
      <i class="fas fa-times btn--close"></i>
    </a>
    <b-row>
      <b-col md="8" offset-md="2">
        <h1 class="text--extrabold" v-scroll-reveal>
          New Release of Townhomes  <br/>
              Coming 2024
        </h1>
        <h3 v-scroll-reveal="{ delay: 150 }">
          Register Today to Receive Updates About This Exciting Opportunity
        </h3>

        <br />
        <br />

        <b-form
          id="subForm"
          class="js-cm-form registrationForm"
          method="post"
          @submit.prevent="contactform"
        >
          <b-row>
            <b-col sm="6">
              <b-form-group>
                <b-form-input
                  type="text"
                  class="form-control req"
                  id="fieldgdytkt"
                  name="cm-f-wdljuy"
                  v-model="form.firstname"
                  placeholder="FIRST NAME*"
                  aria-label="FIRST NAME*"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <b-form-input
                  type="text"
                  class="form-control req"
                  id="fieldgdytki"
                  name="cm-f-wdljuj"
                  v-model="form.lastname"
                  placeholder="LAST NAME*"
                  aria-label="LAST NAME*"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group>
                <b-form-input
                  type="email"
                  class="form-control req js-cm-email-input"
                  id="fieldEmail"
                  name="cm-ejdnd-ejdnd"
                  v-model="form.email"
                  placeholder="EMAIL ADDRESS*"
                  aria-label="EMAIL ADDRESS*"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <b-form-input
                  type="text"
                  class="form-control req numonly"
                  id="fieldgdytul"
                  name="cm-f-wdljut"
                  v-model="form.phone"
                  placeholder="PHONE NUMBER*"
                  aria-label="PHONE NUMBER*"
                  maxlength="12"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <b-form-input
                  type="text"
                  class="form-control req"
                  id="fieldgdytur"
                  name="cm-f-wdljui"
                  v-model="form.postalcode"
                  placeholder="POSTAL CODE*"
                  aria-label="POSTAL CODE*"
                  required
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group>
                <b-form-select
                  id="fieldgdytuh"
                  name="cm-f-wdljud"
                  class="req form-control"
                  required
                  v-model="form.howdidyouhearaboutus"
                  aria-label="HOW DID YOU HEAR ABOUT US?*"
                >
                  <option :value="null" disabled
                    >HOW DID YOU HEAR ABOUT US?*</option
                  >
                  <option value="Agent/Broker">Agent/Broker</option>
                  <option value="BuzzBuzzHome">BuzzBuzzHome</option>
                  <option value="Digital Ad">Digital Ad</option>
                  <option value="Direct Mail/Flyer">Direct Mail/Flyer</option>
                  <option value="Google/Online Search"
                    >Google/Online Search</option
                  >
                  <option value="Magazine">Magazine</option>
                  <option value="Newspaper">Newspaper</option>
                  <option value="Referral">Referral</option>
                  <option value="Signage">Signage</option>
                  <option value="Social Media">Social Media</option>
                  <option value="Website">Website</option>
                  <option value="Other">Other</option>
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col sm="6">
              <b-form-group>
                <b-form-select
                  id="fieldgdytud"
                  name="cm-f-wdljuh"
                  class="req form-control"
                  required
                  v-model="form.typeofbuyer"
                  aria-label="TYPE OF BUYER*"
                >
                  <option :value="null" disabled>TYPE OF BUYER*</option>
                  <option value="First Time">First Time</option>
                  <option value="Move Up">Move Up</option>
                  <option value="Downsize">Downsize</option>
                  <option value="Investment">Investment</option>
                </b-form-select>
              </b-form-group>
            </b-col>

            <b-col sm="6" v-if="form.howdidyouhearaboutus == 'Other'">
              <div class="form-group">
                <b-form-input
                  type="text"
                  class="form-control"
                  id="fieldgdytuk"
                  name="cm-f-wdltly"
                  required
                  v-model="form.specify"
                  placeholder="Specify"
                  
                ></b-form-input>
              </div>
            </b-col>
            <b-col sm="12" class="agentRadio">
              <label for="realtor">
                ARE YOU A REALTOR®?
                <strong>*</strong>
              </label>
              <div>
                <b-form-radio-group label="Individual radios" required aria-label="ARE YOU A REALTOR®?">
                  <b-form-radio v-model="form.agent" name="realtor" value="NO"
                    >NO</b-form-radio
                  >
                  <b-form-radio v-model="form.agent" name="realtor" value="YES"
                    >YES</b-form-radio
                  >
                </b-form-radio-group>
              </div>
              <b-row class="pt-2">
                <b-col sm="12" md="12">
                  <!-- <div class="pr-15">IF YES, PLEASE SHARE YOUR AGENT NAME</div> -->
                </b-col>
                <b-col sm="12" md="12">
                  <b-form-input
                    v-if="form.agent == 'YES'"
                    type="text"
                    class="Raleway"
                    placeholder="AGENT NAME*"
                    name="agent name"
                    v-model="form.agentName"
                    :required="form.agent == 'YES'"
                    aria-label="AGENT NAME*"
                  ></b-form-input>

                  <div class="d-flex consent-box">
                    <input type="checkbox" 
                    name="consent" 
                    id="consent-checkbox"
                    aria-label="Consent*"
                    v-model="form.consent"
                    required>
                    <p style="font-size: 80%">
                      {{form.agent}} By completing this registration form for New Seaton, I expressly provide my consent to receive electronic messages from New Seaton, and from the builders of New Seaton, retroactively, today and in the future and for any projects. I understand that I may withdraw my consent by unsubscribing at any time.*
                    </p>
                  </div>
                  
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="6" offset-sm="3" class="buttonwrapper">
              <!-- <input type="submit" class="btn btn--red submitreq js-cm-submit-button btn-block" value="SUBMIT"> -->
              <vue-recaptcha
                sitekey="6Lc3juUUAAAAADPEYkdRV8D4TW_E6D9elYLyvOW8"
                ref="invisibleRecaptcha"
                @verify="onVerify"
                style="margin-bottom: 1rem"
              ></vue-recaptcha>
              <input
                type="submit"
                class="btn btn--red btn-block"
                :disabled="!formIsValid"
                value="SUBMIT"
                aria-label="Submit"
              />
            </b-col>
            <b-col md="12" class="text-center">
              <br />
              <p
                style="font-size: 80%;position:relative;display:inline-block;padding:0 15px"
              >
                <span
                  style="font-size: 39px;line-height: 0;position: absolute;left: 0;bottom: 2px;"
                  >*</span
                >
                = Required Fields
              </p>
              
            </b-col>
          </b-row>
        </b-form>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import axios from "axios";
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { VueRecaptcha },
  data() {
    return {
      errors: [],
      form: {
        email: "",
        firstname: "",
        lastname: "",
        phone: "",
        postalcode: "",
        howdidyouhearaboutus: null,
        typeofbuyer: null,
        captcha: null,
        consent: null,
        specify: "",
        agent: "",
        agentName: "",
        sourceUrl: "",
        hubspotutk: 0,
        sourceQuery:""
      },
      triggered: false
    };
  },
  head: {
    script: [
      {
        src: "//js.hs-scripts.com/3390596.js",
        body: true,
        async: true,
        id: "hs-script-loader",
        type: "text/javascript"
      }
    ]
  },
  mounted() {
    this.$root.layout.methods.triggerViewPortAnimation();
    this.$nextTick(() => {
      this.form.sourceUrl = window.location.href;
      this.form.hubspotutk = localStorage.getItem("hubspotutk");
      this.getPageQuery();
      
      // console.log(this.form.sourceUrl);
      // console.log(this.form.hubspotutk);
    });
  },
  computed: {
    formIsValid() {
      if (
        this.form.email &&
        this.form.firstname &&
        this.form.lastname &&
        this.form.phone &&
        // this.form.city &&
        this.form.postalcode &&
        this.form.howdidyouhearaboutus &&
        this.form.consent &&
        this.form.agent != "" &&
        this.form.captcha != null
      ) {
        return true;
      }

      // if (this.form.agentname && this.form.agentaddress) {
      //   return true;
      // }
    }
  },
  methods: {
    // mail it
    goBack() {
      this.$router.go(-1);
    },
    contactform: function() {
      console.log(this.form.agent);
      if (this.form.agent == "NO") {
        this.form.agentName = "";
      }
      let _this = this;
      jQuery("input[type='submit']").hide();
      jQuery
        .ajax({
          method: "POST",
          url: "/submit_regis_form.php",
          data: {
            email: _this.form.email,
            firstname: _this.form.firstname,
            lastname: _this.form.lastname,
            phone: _this.form.phone,
            postalcode: _this.form.postalcode,
            typeofbuyer: _this.form.typeofbuyer,
            howdidyouhearaboutus: _this.form.howdidyouhearaboutus,
            specify: _this.form.specify,
            consent: _this.form.consent,
            sourceUrl: _this.form.sourceUrl,
            hubspotutk_cookie: _this.form.hubspotutk,
            agent: _this.form.agent,
            agentName: _this.form.agentName,
            // context: {
            //   hutk: ":hutk", // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
            //   pageUri: "https://newseaton.com/register",
            //   pageName: "New Seaton General Registration"
            // }
          },
          crossDomain: true,
          success: function(data) {
            console.log(data)
          }
        })
        .done(function(msg) {
          console.log("message: " + msg);
          // window.location.href = "/thankyou/";
          jQuery("input[type='submit']").show();
          _this.$router.push({
            path: "/thankyou" + _this.form.sourceQuery
          });
        });
    },
    onVerify: function(response) {
      if (response != null) {
        this.form.captcha = response;
      } else {
        this.form.captcha = null;
      }
    },
    getPageQuery() {
      this.form.sourceQuery = localStorage.getItem("sourceQuery");
    }
  },
  transition: {
    mode: "out-in",
    css: false,
    appear: true,

    enter(el, done) {
      done();
    },
    leave(el, done) {
      done();
    }
  },
};
</script>

<style scoped lang="scss">
#subForm {
  .agentRadio {
    font-family: "Gotham-Bold";
    font-size: 0.9rem;
    text-align: left;
  }
  .Raleway {
    font-family: "Raleway", sans-serif;
  }

  .consent-box {
    align-items: baseline;
    
    #consent-checkbox {
      position: relative;
      top: 4px;
      margin-right: 10px;
      accent-color: #d62c3b;
    }

    p {
    }
  }
}
</style>
